import React, { Component } from 'react';
import { Icon, Layout, Row, Col, Card, Table } from 'antd';
import { Link } from 'react-router-dom';
import { withAsyncActions } from 'react-async-client';
import { Field } from 'formik';


import { project_application } from 'constants/routes';
import { getAllApplications, getDistributors, getBonuses } from 'actions/asyncActions';
import withForm from 'components/hocs/withForm';
import Select from 'components/common/form/Select';
import DatePicker from 'components/common/form/DatePicker';
import ProjectDistributors from 'components/common/fields/project/ProjectDistributors';
import {formatMoney, mapIndexed} from 'utils/ramdaAdditions.js';
import Breakpoint from 'components/layout/Breakpoint.js';

function getBonusStatus(value) {
    if (!value || typeof value  === "string") return
    if (value.paid_cashback && value.price) {
        return 'Выплаченный Cashback';
    }
    return 'Планируемый Cahsback';
}



function totalAmountExecuted(data) {
    if(data.length === 0) return 0
    const fl = data.filter(x=> x.paid_cashback === 1)
    return computation(fl)
}

function totalAmountPlaned(data) {
    if(data.length === 0) return 0
    const fl = data.filter(x=> x.paid_cashback === 0)
    return computation(fl)
}

function computation(data) {
    let total = 0
    data.forEach(sum=> {
        if(sum) total += +sum.price
    })
    return total
}

function TableCardBonusProject(app, index) {
    return (
        <Card className="table-card" key={app.id}>
            
            <Row type="flex" justify="space-between">
                <span className="index">{index + 1}</span>
                <Link to={project_application.stringify(app)}>
                    <Icon type="eye-o" />
                </Link>
            </Row>
            <Row className="bold m-t-10">
                <Link to={project_application.stringify(app)}>
                    {app.name}
                </Link>
            </Row>
            <Row className="table-card-inline m-t-20">
                <span className="key">Дистрибьютор: </span>
                <ProjectDistributors id={app.distributor_id} key={app.id} />
            </Row>
            <Row className="table-card-inline">
                <span className="key">Статус: </span>
                {getBonusStatus(app.status)}
            </Row>
            <Row className="table-card-inline">
                <span className="key">Cashback: </span>
                <span className="bold">{formatMoney(app.bonusInWork || app.bonusPaid || app.bonusPlanned || 0)}</span>
            </Row>
        </Card>
    );
}

function filterApps(apps, v) {
    return apps.filter((a) => {
        switch (v.status) {
            case 'В работе':
                if (a.status !== 'OFFER_APPROVED') {
                    return false;
                }
                break;
            case 'Выплачено':
                if (a.status !== 'COMPLETE' && a.status !== 'PAID_PART') {
                    return false;
                }
                break;
            case 'Планируется':
                if (a.status === 'COMPLETE' || a.status === 'PAID_PART' || a.status === 'OFFER_APPROVED') {
                    return false;
                }
                break;
            default:
        }
        if (v.distributor) {
            if (a.distributor_id !== v.distributor) {
                return false;
            }
        }
        if (v.from) {
            if (v.from.isAfter(a.created_at)) {
                return false;
            }
        }
        if (v.to) {
            if (v.to.isBefore(a.created_at)) {
                return false;
            }
        }
        return true;
    });
}

@withForm({})
@withAsyncActions({
    getAllApplications,
    getDistributors,
    getBonuses,
}, { dispatchOnMount: true })
export default class Bonus extends Component {
    columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            className: 'bold',
        },
        {
            title: 'Название',
            dataIndex: 'name',
            key: 'name',
            render: (value, row) => (
                <Link to={project_application.stringify(row)}>
                    {value}
                </Link>
            ),
        },
        {
            title: 'Проект',
            dataIndex: 'project_name',
            key: 'project_name',
            render: (value, row) => (
                <Link to={project_application.stringify(row)}>
                    {value}
                </Link>
            ),
        },
        {
            title: 'Дистрибьютор',
            dataIndex: 'distributor_id',
            key: 'distributor_id',
            render: (value, row) => <ProjectDistributors id={value} app={row.id} />,
            // 
        },
        {
            title: 'Статус Cashback',
            dataIndex: 'status',
            key: 'status',
            render: (_, value) => {
                return getBonusStatus(value);
            }
        },
        {
            title: 'Cashback',
            dataIndex: 'cashback',
            key: 'cashback',
            className: 'bold',
            render: (_, row) => {
                  return row.price + " ₽";
            }
        },
        {
            title: '',
            dataIndex: 'actions',
            key: 'actions',
            className: 'bold',
            render: (_, row) => (
                <Link to={project_application.stringify(row)}>
                    <Icon type="eye-o" />
                </Link>
            )
        },
    ];

    render() {
        const { data: { applications=[] }, meta } = this.props.getAllApplications;
        const { distributors } = this.props.getDistributors;
        const { values } = this.props;
        const filteredApps = filterApps(applications, values);

        return (
            <Layout className="bonus container page main-content">
                <div className="title">
                    Ваш персональный бонус<br />
                </div>
                <Row gutter={30}>
                    <Col md={8} sm={10}>
                        <Card title="Выплаченный Cashback:" bordered={false}>
                            <span className="counters">{totalAmountExecuted(applications) + " ₽"}</span>
                        </Card>
                    </Col>
                    <Col md={8} sm={10}>
                        <Card title="Планируемый Cashback:" bordered={false}>
                            <span className="counters">{totalAmountPlaned(applications) + " ₽"}</span>
                        </Card>
                    </Col>
                </Row>

                <div className="controls-title">
                    Статистика
                </div>
                <Row type="flex" className="controls">
                    <div className="controls-left-col">
                        <div>
                            <span className="controls-label">с</span>
                            <div className="select-container">
                                <Field
                                    name='from'
                                    component={DatePicker}
                                    placeholder='Дата'
                                />
                            </div>
                        </div>
                        <div>
                            <span className="controls-label">по</span>
                            <div className="select-container">
                                <Field
                                    name='to'
                                    component={DatePicker}
                                    placeholder='Дата'
                                />
                            </div>
                        </div>
                    </div>
                    <div className="controls-right-col">
                        <div className="select-container">
                            <Field
                                name='distributor'
                                component={Select}
                                options={distributors && distributors.data}
                                placeholder='Дистрибьютор'
                            />
                        </div>
                    </div>
                </Row>

                <Breakpoint min="sm">
                    
                    <Table
                        rowKey="id"
                        columns={this.columns}
                        dataSource={filteredApps}
                        pagination={false}
                        loading={meta.pending}
                    />
                </Breakpoint>
                <Breakpoint max="sm">
                    {mapIndexed(TableCardBonusProject, filteredApps)}
                    {filteredApps.length === 0 && (<div>Нет данных</div>)}
                </Breakpoint>
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/bonus/Bonus.js